export interface BundleItem {
  BundledDiscount: number;
  DiscountLevel: number;
  IsFree: boolean;
  Webcode: string;
  Manufacturer: string;
  ProductUrl: string;
  ItemStatus: string;
  Description: string;
  SellingPrice: number;
  RegularPrice: number;
  Category: string;
  ImageUrl: string;
  BundleId: number;
  IsAnchor: boolean;
  StockingStatus: string;
  ThumbnailUrl: string;
  VendorItemNo: string;
  RequestedQuantity: number;
  IsInCart: boolean;
  HasUnsavedChanges: boolean;
}

export interface BundleLine {
  item: BundleItem;
  quantity: number;
}

export interface Bundle {
  lines: BundleLine[];
  price: number;
}

export class BundleBuilderState {
  anchor: BundleLine;
  bundle: Bundle = { price: 0, lines: [] };
  filteredBundleItems: BundleItem[] = [];
  categories: Category[] = [];
  currentCategory: Category;
  modified: boolean;
}

export type CategoryId = string | CategoryType;

export interface Category {
  name: string;
  note?: string;
  id: CategoryId
}

export enum CategoryType {
  Free,
  Level1,
  Level2,
  Anchor
}

export interface BundleLineDto {
  BundleId: number;
  Webcode: string;
  Quantity: number;
}

export interface BundlePricing { }

